import { DetermineTextColor } from "../utils/DetermineTextColor";
import { enumElementDrawStates, kbuttonLabelHeight, kSmallIcon } from "../constants";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { QButton } from "./QButton";
import { shadeColor } from "../utils/shadeColor";
import { Globals } from "./Globals";
import { doDrawIcon } from "../utils/doDrawIcon";

export class QIconButton extends QButton {
  constructor() {
    super();
    this.fEnabledImage = null;
    this.fDisabledImage = null;
    this.fSizing = kSmallIcon;
    this.fHelpCode = null;
    this.fCenterIcon = true;
    this.fIconHInset = 5;
    this.fFontIconOverride = null;
  }

  SetSizing(sizing) {
    this.fSizing = sizing;
  }

  SetEnabledImage(enabledImage) {
    this.fEnabledImage = enabledImage;
  }

  SetDisabledImage(disabledImage) {
    this.fDisabledImage = disabledImage;
  }

  GetCursor() {
    return "pointer";
  }

  DoRenderContent(drawBuffer) {
    if (this.fShowLabel) {
      this.DrawLabel(drawBuffer);
    }

    if (this.fFontIconOverride != null) this.DrawFAIcon(drawBuffer);
    else if (this.fEnabledImage) this.DrawIcon(drawBuffer);
  }

  DrawBorderGlow(ctx) {
    var parent = this.GetParentElement();
    if (parent == null) parent = this;
    var pDrawState = parent.GetDrawState();
    if (!parent.fDrawPad && Globals._browserStr.indexOf("IE") === -1) {
      // disable icon border in internet explorer
      var shadowBlur = 2;
      var shadowColor = DetermineTextColor(uFramelessPanelColor);
      switch (pDrawState) {
        case enumElementDrawStates.Hover:
          shadowBlur = 5;
          shadowColor = shadeColor(Globals._accountInfo.GetButtonColor(), -8);
          break;
        case enumElementDrawStates.MouseDown:
          shadowBlur = 1;
          shadowColor = shadeColor(Globals._accountInfo.GetButtonColor(), -10);
          break;
        default:
          break;
      }
      ctx.shadowBlur = shadowBlur;
      ctx.shadowColor = shadowColor;
    }
  }

  DrawFAIcon(drawBuffer) {}

  DrawIcon(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var iconImage = this.fEnabledImage;
    if (this.fFontIconOverride) return;
    if (this.GetDrawState() === enumElementDrawStates.Disabled) {
      iconImage = this.fDisabledImage;
      ctx.globalAlpha = 0.4;
    }
    var parent = this.GetParentElement();
    if (parent == null) parent = this;

    var dstWidth = this.fSizing.imageWidth;
    var dstHeight = this.fSizing.imageHeight;

    var xPos, yPos;

    if (this.fCenterIcon)
      xPos = Math.floor(parent.fHorzOffset + (parent.fWidth - dstWidth) / 2) + 0.5;
    else xPos = Math.floor(parent.fHorzOffset + this.fIconHInset) + 0.5;

    if (this.fShowLabel && this.fCenterIcon)
      yPos =
        Math.floor(parent.fVertOffset + (parent.fHeight - kbuttonLabelHeight - dstHeight) / 2) +
        0.5;
    else yPos = Math.floor(parent.fVertOffset + (parent.fHeight - dstHeight) / 2) + 0.5;

    doDrawIcon(
      ctx,
      iconImage,
      0,
      0,
      iconImage.width,
      iconImage.height,
      xPos,
      yPos,
      dstWidth,
      dstHeight,
      true
    );

    ctx.globalAlpha = 1;
    ctx.shadowBlur = 0;
  }
}
